import { IntegrationDefinition } from '../IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const CineplexDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Cineplex,
  hasCustomUI: false,
  friendlyName: 'Cineplex Displays',
  description: `Defines the properties required for a Cineplex integration.`,
  category: IntegrationCategoryEnum.Displays,
  platforms: [],
  type: IntegrationTypeEnum.ContentTargeting,
  settings: {},
  properties: {},
  mobilePermissions: [],
};

export const definition = CineplexDefinition;
